import { Fragment, type FC, type ReactNode } from "react";

export interface DataGridItem {
  label: string;
  value: ReactNode;
  id?: string;
}

interface DataGridProps {
  items: DataGridItem[];
  dataTest?: string;
}

export const DataGrid: FC<DataGridProps> = ({ items, dataTest }) => {
  return (
    <div className="grid w-full grid-cols-1 gap-2 lg:grid-cols-[270px_auto]">
      {items.map(({ label, value, id }) => {
        const key = id ?? label;
        return (
          <Fragment key={key}>
            <p
              className="font-light"
              data-test={dataTest && id ? `${dataTest}-${id}-label` : undefined}
            >
              {label}
            </p>
            <div
              className="font-medium"
              data-test={dataTest && id ? `${dataTest}-${id}-value` : undefined}
            >
              {value}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};
